import React from 'react';
import Main from './components/Main';
import BaseLayout from './layout/BaseLayout';

function App() {
  return (
    <BaseLayout>
      <Main />
    </BaseLayout>
  );
}

export default App;
